/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

// TODO: Replace with correct urls
export const environment = {
  production: false,
  cn_environment: false,
  features: {
    registerWithMobileNumberCountries: ['cn', 'hk'],
  },
  urls: {
    ui: 'https://signup.porsche-preview.com',
    api: 'https://api.signup.porsche-preview.com/',
    localisation: 'https://localise.profile.porsche.com/',
    localisationCN: 'https://localise.profile.porsche.cn/',
    shortLinkApi: 'https://shortlink-profile.porsche-preview.com/',
    consentWidget: 'https://privacy.porsche-preview.com/static/consent-webcomponent/consent-webcomponent.js',
  },
  oauth: {
    clientId: 'p9AVeef5rlZUaIdiVeZ9liyL6D7I3sDK',
    domain: 'identity.porsche-preview.com',
    authorizationParams: {
      redirect_uri: 'https://signup.porsche-preview.com/auth/callback',
      audience: 'https://api.porsche-preview.com',
      scope: 'openid email profile',
    },
    httpInterceptor: {
      allowedList: [
        {
          uriMatcher: (uri: string) =>
            uri.match(
              RegExp('https://api.signup.porsche-preview.com/registration/v[0-9]*/[a-z]{2}/[a-z]{2}_[A-Z]{2}/register/organisation'),
            ) !== null,
        },
        {
          uriMatcher: (uri: string) =>
            uri.match(
              RegExp('https://api.signup.porsche-preview.com/registration/v[0-9]*/[a-z]{2}/[a-z]{2}_[A-Z]{2}/action/secure-resend'),
            ) !== null,
        },
        {
          uriMatcher: (uri: string) =>
            uri.match(RegExp('https://api.signup.porsche-preview.com/confirmation/v[0-9]*/[a-z]{2}/[a-z]{2}_[A-Z]{2}/secure-auth')) !==
            null,
        },
        {
          uriMatcher: (uri: string) =>
            uri.match(RegExp('https://api.signup.porsche-preview.com/confirmation/v[0-9]*/[a-z]{2}/[a-z]{2}_[A-Z]{2}/secure-confirm')) !==
            null,
        },
      ],
    },
  },
  apiKeyWhiteListUrls: ['api.signup.porsche-preview.com'],
  navigationOptions: {
    environment: 'pp',
  },
  cookieConsent: {
    enable: true,
    usc: {
      useItpBridge: true,
      enableForLocalhost: false,
    },
  },
  logger: {
    showLogs: true,
    showWarnings: true,
  },
  googleTagManagerV2: {
    enable: true,
    containerId: 'GTM-W2NKNJZ',
    skipInitialPageView: true,
    data: {
      context: {
        applicationId: 'myporsche_signup',
        environment: 'PP',
      },
    },
  },
  externalUrls: {
    portalAddVehicle: 'https://my.porsche-preview.com/core/:country/:locale/vehicles/add',
    personalData: 'https://profile.porsche-preview.com/myprofile/:country/:locale/personal-data',
    myPorscheHome: 'https://my.porsche-preview.com/core/:country/:locale/home',
    pictureService: 'https://signup.porsche-preview.com/pictures',
  },
  fullstory: {
    devMode: false,
    orgId: 'o-6H95-eu1',
  },
  mockServiceWorker: {
    enabled: false,
  },
  ngxs: {
    developmentMode: false,
    devToolsDisabled: true,
  },
  angularCommonAssets: 'https://signup.porsche-preview.com/assets/static/angular-common/',
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error'
